import { render, staticRenderFns } from "./RegistEdit.vue?vue&type=template&id=ef5c5482&scoped=true&"
import script from "./RegistEdit.vue?vue&type=script&lang=js&"
export * from "./RegistEdit.vue?vue&type=script&lang=js&"
import style0 from "./RegistEdit.vue?vue&type=style&index=0&id=ef5c5482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5c5482",
  null
  
)

export default component.exports